import { Resource } from "react-admin";
import { EmployeeDetails } from "../details/EmployeeDetails";
import { DefaultList } from "../misc/DefaultList";

export const employeesResource = (
  <Resource
    key="employees"
    name="employees"
    list={DefaultList}
    edit={EmployeeDetails}
    options={{ label: "Mitarbeiter" }}
    recordRepresentation={(employees) => employees.name.replaceAll(" ", "\u00A0")}
  />
);
